import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {ApiService} from "../../services/api.service";
import {GetKPISgestionJornadaResponseDTO} from "../../../dtos/response/getKPISgestionJornada.response.dto";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {DetalleJornadaDTO} from "../../../dtos/detalleJornada.dto";
import {GetDetalleJornadaResponseDTO} from "../../../dtos/response/getDetalleJornada.response.dto";
import {JornadaService} from "../../services/jornada.service";
import {JornadaDTO} from "../../../dtos/jornada.dto";
import moment from "moment/moment";
import {PostFinalizarViajeResquestDTO} from "../../../dtos/request/postFinalizarViaje.resquest.dto";
import {EventService} from "../../services/event.service";
import {HttpErrorResponse} from "@angular/common/http";
import {NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-modal-cancelar-jornada',
  standalone: true,
  imports: [
    NgIf,
    FormsModule
  ],
  templateUrl: './modal-cancelar-jornada.component.html',
  styleUrl: './modal-cancelar-jornada.component.scss'
})
export class ModalCancelarJornadaComponent {

  public detalleJornada: DetalleJornadaDTO;
  public jornada: JornadaDTO;
  public comentario: string;
  public enviando: boolean = false;

  constructor(private modalRef: BsModalRef, private apiService: ApiService, private jornadaService: JornadaService,
              private eventService: EventService, private toastr: ToastrService, private userService: UserService) {
    this.jornada = this.jornadaService.getJornadaSeleccionada();
    this.getDetalleJornada();
    this.eventService.subscribe('JORNADA_ACTUALIZADA_MQTT_EVENT', (jornada: JornadaDTO) => {
      if(jornada.uuid == this.jornada.uuid) {
        this.jornada = jornada;
        this.detalleJornada = jornada;
      }
    })
  }

  close() {
    this.modalRef.hide();
  }

  tienePermisoCancelarJornada(): boolean {
    return this.userService.tienePermiso('JORNADA_CANCELAR');
  }

  muestraHora(fecha: string) {
    return moment.utc(fecha).local().format('HH:mm');
  }

  getDetalleJornada(init: boolean = false) {
    this.apiService.getDetalleJornada(this.jornada.uuid)
      .subscribe((resp) => this.getDetalleJornadaSuccess(resp), (error) => this.getDetalleJornadaError(error));
  }

  getDetalleJornadaSuccess(getDetalleJornadaResponseDTO: GetDetalleJornadaResponseDTO) {
    console.log('exito get detalle jornada', getDetalleJornadaResponseDTO);
    this.detalleJornada = getDetalleJornadaResponseDTO.data;
  }

  getDetalleJornadaError(error: HttpErrorResponse) {
    console.log('error get detalle jornada', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  putCancelarJornada() {
    this.enviando = true;
    this.apiService.putCancelarJornada(this.jornada.uuid, this.comentario)
      .subscribe(res => this.putCancelarJornadaSuccess(res), error => this.putCancelarJornadaError(error));
  }


  putCancelarJornadaSuccess(generalResponseDTO: GeneralResponseDTO) {
    console.log('put cancelar joranda success', generalResponseDTO);
    //alert(generalResponseDTO.msg);
    this.enviando = false;
    this.close();
    setTimeout(() => this.toastr.success(generalResponseDTO.msg, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false }), 400);
    this.eventService.publish('CANCELAR_JORNADA_SUCCESS');
  }

  putCancelarJornadaError(error: HttpErrorResponse) {
    console.log('put cancelar jornada error', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_PUT_CANCELAR_JORNADA_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

}
